<!-- <div class="">
  <div class=""> -->
<!-- <div class="">
      <div class="">Create New Business Component</div>
    </div> -->
<!-- <div class=""> -->
<form [formGroup]="createBusinessComponentForm">
  <section class="bc-create-body-section">
    <div class="bc-create-section">
      <div class="bc-info-text1">
        <span>The business component name should be unique and not already in use. The name is limited to 50 characters.</span>
      </div>
      <div class="bc-info-text1">
        <span>A business component must have at least one associated project to be available for time or expense
          survey creation.</span>
      </div>

      <div class="bc-name-q-section">
        <div class="bc-name-section">
          <label class="bc-name-required" for="businessComponentName"><i class="fas fa-asterisk required-asterisk-icon"></i>Business Component Name</label>
          <input id="businessComponentName" [formControl]="businessComponentNameControl" class="form-control"
            [ngClass]="{'highlight-error': businessComponentNameControl.touched}" (blur)="markBCNameAsUntouched()"
            maxlength="50" />
          <small
            *ngIf="showBCNameError && businessComponentNameControl.value?.toString().trim().toLowerCase() !== 'non-business component time'.toLowerCase()"
            class="error-text-color"
          >
            BC name already in use.
          </small>
          <small *ngIf="businessComponentNameControl.errors?.forbiddenValue && businessComponentNameControl.touched" class="error-text-color">
            The name you have chosen is reserved for internal use.
          </small>
          <small *ngIf="businessComponentNameControl.value?.toString().trim().toLowerCase() === 'non-business component time'.toLowerCase()" class="error-text-color">The name you have chosen is reserved for internal use.</small>
        </div>

        <div class="bc-qualified-percentage">
          <label for="qualifiedPercentage">Qualified Percentage</label>
        
          <div class="input-container percentage-wrapper">
            <input type="number" id="qualifiedPercentage" [formControl]="bcQualifiedPercentageControl" placeholder="0"
              min="0" value="100" max="100" class="form-control"
              [ngClass]="{'highlight-error': bcQualifiedPercentageControl.touched}"
              (input)="restrictDecimalPlaces($event)" (blur)="markBCQPercentageAsUntouched()" />
            <!-- <span class="percentage-sign"> <i class="fa-solid fa-percent"></i></span> -->
            <small *ngIf="showBCQualifiedPercentageError" class="error-text-color">
              Qualified Percentage must be a number between 0-100%.
            </small>
          </div>
        </div>
      </div>

      <div class="bc-number-bc-type-section">
        <div class="bc-number-section">
          <label class="bc-number-required" for="businessComponentNumber"><i class="fas fa-asterisk required-asterisk-icon"></i>BC Number</label>
          <input id="businessComponentNumber" [formControl]="businessComponentNumberControl" class="form-control"
            [ngClass]="{'highlight-error': businessComponentNumberControl.touched}"
            (blur)="markBCNumberAsUntouched()" />
        <small
          *ngIf="showBCNumberError && businessComponentNumberControl.value?.toString().trim().toLowerCase() !== 'non-business component time'.toLowerCase()"
          class="error-text-color"
        >
          BC number already in use.
        </small>          
        <small *ngIf="businessComponentNumberControl.errors?.forbiddenValue && businessComponentNumberControl.touched" class="error-text-color">
            The number you have chosen is reserved for internal use.
          </small>
          <small *ngIf="businessComponentNumberControl.value?.toString().trim().toLowerCase() === 'non-business component time'.toLowerCase()" class="error-text-color">The number you have chosen is reserved for internal use.</small>
        </div>

        <div class="bc-type-section">
          <label class="bc-type-required"><i class="fas fa-asterisk required-asterisk-icon"></i>BC Type</label>
          <!-- <div class="input-icon-right" >
                <custom-dropdown [options]="bcTypeOptions" [selectText]=''
                  (optionSelectedEvent)=" selectBCType($event)">
                </custom-dropdown>
              </div> -->
          <div>
            <select id="projectType" (change)="selectBCType($event)" class="bc-type-custom-select">
              <option value="" disabled selected>Select BC Type</option>
              <option *ngFor="let option of bcTypeOptions" [value]="option.id">
                {{ option.value }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="bc-client-project-select-section">
        <label class="bc-client-project-label">
          <i class="fas fa-asterisk required-asterisk-icon"></i>Add client projects to this BC
        </label>
        <ng-multiselect-dropdown style="margin-top: 0 !important;" [placeholder]="'Select client projects'"
          [settings]="dropdownSettings" [data]="clientProjects" [(ngModel)]="clientProjectsAdded"
          [ngModelOptions]="{standalone: true}" class="full-width">
        </ng-multiselect-dropdown>
      </div>
    </div>
  </section>

  <footer class="endFormSubmit info-tile">
    <button type='button' class="btn btn-success" (click)="createBusinessComponent()"
      [disabled]="!isValidForm()">Create</button>
    <button class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
  </footer>

</form>
<!-- </div> -->
<!-- <div class="">
      <button type="submit" class="btn btn-success custom-success" (click)="createBusinessComponent()"
        [disabled]="!isValidForm()">Create
      </button>
      <button type="button" class="link-button" (click)="closeModel()">Cancel</button>
    </div> -->
<!-- </div>
</div> -->